import { GrLineChart } from "react-icons/gr";
import { FaUsers } from "react-icons/fa6";
import { FaHandFist } from "react-icons/fa6";

const YouGet = () => {
  const features = [
    {
      plainText: (
        <h2 className="text-white font-medium text-left text-3xl">
          What <br />
          <span className="font-semibold text-6xl">You Get</span> <br />
          as a <br />{" "}
          <span className="font-semibold text-xl">Founders’ circle member</span>
        </h2>
      ),
    },
    {
      icon: <GrLineChart className="text-6xl text-white" />,
      title: "Enhanced Brand Image",
      description:
        "We connect your company with a cause that promotes trust and credibility. Leads to more customers, customers loyalty.",
    },
    {
      icon: <FaUsers className="text-6xl text-white" />,
      title: "Greater Visibility",
      description:
        "Through social media, events, and press coverage, we’ll amplify your company’s involvement in fighting corruption. All the events IEJL doing, will show them as founders. You can also self promote on your webpage.",
    },
    {
      icon: <FaHandFist className="text-6xl text-white" />,
      title: "Long-Term Impact",
      description:
        "By aligning with ethical business practice, you’ll position your brand as forward-thinking and ethical, building customer loyalty and trust.",
    },
  ];

  return (
    <section className="py-16 px-10 md:px-40 bg-gray-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* First row: Left small, Right large */}
          <div className="p-6 bg-[#004E98] shadow-lg rounded-tr-full text-center md:col-span-1 pt-24">
            {features[0].plainText}
          </div>
          <div className="p-12 bg-[#DB5800] shadow-lg flex flex-col items-center text-center text-white md:col-span-2">
            {features[1].icon}
            <h3 className="text-2xl font-semibold mb-2 mt-10">
              {features[1].title}
            </h3>
            <p className="text-gray-200 mt-6 font-light">
              {features[1].description}
            </p>
          </div>

          {/* Second row: Left large, Right small */}
          <div className="p-12 bg-[#DB5800] shadow-lg flex flex-col items-center text-center text-white md:col-span-2">
            {features[2].icon}
            <h3 className="text-2xl font-semibold mb-2 mt-10">
              {features[2].title}
            </h3>
            <p className="text-gray-200 mt-6 font-light">
              {features[2].description}
            </p>
          </div>
          <div className="p-8 bg-[#DB5800] shadow-lg flex flex-col items-center text-center text-white md:col-span-1">
            {features[3].icon}
            <h3 className="text-2xl font-semibold mb-2 mt-10">
              {features[3].title}
            </h3>
            <p className="text-gray-200 mt-6 font-light">
              {features[3].description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YouGet;
